import * as React from 'react';
import styled from 'styled-components';
const footer = (props) => {
    return (React.createElement(Footer, null, props.children));
};
export default footer;
const Footer = styled.footer `
  background-color: #000;
  grid-area: footer;
  padding: 20px;
`;
//# sourceMappingURL=Footer.js.map


// WEBPACK FOOTER //
// ./src/components/Footer.js